export default __webpack_public_path__ + "static/balsamiq-121099271de659cd7e5bb2af144df562.svg";